import React from 'react'
import styled from 'styled-components'
import { FONTS } from '../../constants'

export const importModalBody = result => {
  const {
    createdUsers,
    updatedUsers,
    prettyErrors = [],
  } = result

  return (
    <Root>
      <Label>Created: </Label>
      <Text>{ createdUsers }</Text>
      <br />
      <Label>Updated: </Label>
      <Text>{ updatedUsers }</Text>
      <br />
      <Label>Errors: </Label>
      <Text>{ prettyErrors.length }</Text>
      { prettyErrors.map((item) => {
        return <li>{ item }</li>
      }) }
    </Root>
  )
}

const Root = styled.div`
  overflow-y: auto;
  max-height: 200px;
  font-family: ${FONTS.GOTHAM};
  font-size: 14px;
`

const Label = styled.span`
    font-family: ${FONTS.GOTHAM_BOLD};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;
`

const Text = styled.span`
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;
`



// WEBPACK FOOTER //
// ./src/components/modal/import-modal-body.js